var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInformationCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1951_3250)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.50004 7.33398C8.50004 7.05784 8.27618 6.83398 8.00004 6.83398C7.7239 6.83398 7.50004 7.05784 7.50004 7.33398V11.334C7.50004 11.6101 7.7239 11.834 8.00004 11.834C8.27618 11.834 8.50004 11.6101 8.50004 11.334V7.33398Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00004 0.833984C4.042 0.833984 0.833374 4.04261 0.833374 8.00065C0.833374 11.9587 4.042 15.1673 8.00004 15.1673C11.9581 15.1673 15.1667 11.9587 15.1667 8.00065C15.1667 4.04261 11.9581 0.833984 8.00004 0.833984ZM1.83337 8.00065C1.83337 4.5949 4.59428 1.83398 8.00004 1.83398C11.4058 1.83398 14.1667 4.5949 14.1667 8.00065C14.1667 11.4064 11.4058 14.1673 8.00004 14.1673C4.59428 14.1673 1.83337 11.4064 1.83337 8.00065Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.6667 5.33398C8.6667 5.70217 8.36823 6.00065 8.00004 6.00065C7.63185 6.00065 7.33337 5.70217 7.33337 5.33398C7.33337 4.96579 7.63185 4.66732 8.00004 4.66732C8.36823 4.66732 8.6667 4.96579 8.6667 5.33398Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1951_3250"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformationCircle);
export default __webpack_public_path__ + "static/media/InformationCircle.bda7e552b8354e28d01f9b872085b354.svg";
export { ForwardRef as ReactComponent };